import { HttpResponse } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { TypeRegisterData } from 'shell/models/practice-lists';
import { FormRegisterVM } from 'practice/components/register/form';

export const registerResponseTransformer = (
  response: AxiosResponse<HttpResponse<TypeRegisterData>>
): FormRegisterVM => {
  const { data } = response;
  const item = data.payload;
  return {
    type: item?.key?.tipoRegistro || '',
    description: item?.descrizioneRegistro || '',
  };
};
